import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";

const state = {
  trips: null,
  trip: null,
};

const mutations = {
  setTrips(state, trips) {
    state.trips = trips;
  },

  setTrip(state, trip) {
    state.trip = trip;
  },
};

const actions = {
  async getTripById({ commit }, { id, wgId }) {
    const params = {
      idWg: wgId,
      idTrip: id,
    };
    try {
      const api = ApiClient();
      let response = await api.get("/trips", { params });
      commit("setTrip", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getTripById: ", error.message);
      throw error;
    }
  },

  async updateTrip(_, { data, id, wgId }) {
    const params = {
      id,
      idWg: wgId,
    };

    try {
      const api = ApiClient();
      await api.patch("/trips", data, { params });
    } catch (error) {
      console.error("ERROR en updateTrip: ", error.message);
      return error.message;
    }
  },

  async cancelTrip(_, { id, wgId }) {
    const params = {
      idTrip: id,
      idWg: wgId,
    };

    try {
      const api = ApiClient();
      await api.put("/trips/cancel", null, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en cancelTrip: ", error.message);
      return error.message;
    }
  },

  async assignOtherTaxiTrip(_, { id, wgId, data }) {
    const params = {
      id,
      idWg: wgId,
    };
    const urlFormData = qs.stringify({ values: JSON.stringify(data) });
    try {
      const api = ApiClient();
      await api.put("/trips/assignOtherTaxi", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
    } catch (error) {
      console.error("ERROR en assignOtherTaxiTrip: ", error.message);
    }
  },

  async finishTrip(_, { id, wgId, data }) {
    const params = {
      idWg: wgId,
      idTrip: id,
    };
    const urlFormData = qs.stringify(data);

    try {
      const api = ApiClient();
      await api.put("/trips/finish", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en finishTrip: ", error.message);
      return false;
    }
  },

  async getHistoricTripsById({ commit }, { id, wgId }) {
    const params = { id, idWg: wgId };
    try {
      const api = ApiClient();
      let response = await api.get("/trips/historic", { params });
      commit("setTrip", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getHistoricTripById: ", error.message);
      throw error;
    }
  },

  async updateHistoricTrip(_, { id, wgId, data }) {
    const params = {
      idWg: wgId,
      idTrip: id,
    };

    try {
      const api = ApiClient();
      await api.patch("/trips/historic", data, { params });
      return true;
    } catch (error) {
      console.error("ERROR en updateHistoricTrip: ", error.message);
      return false;
    }
  },

  async cancelHistoricTrip(_, { id, wgId }) {
    const params = { idTrip: id, idWg: wgId };
    try {
      const api = ApiClient();
      await api.put("/trips/historic/cancel", null, { params });
    } catch (error) {
      console.error("ERROR en cancelHistoricTrip: ", error.message);
      throw error;
    }
  },
};

const getters = {
  trips(state) {
    return state.trips;
  },

  trip(state) {
    if (state.trip) {
      return state.trip;
    }
  },

  tripId(state) {
    if (state.trip) {
      return state.trip.id;
    }
  },

  tripAudit(state) {
    if (state.trip) {
      return state.trip.auditTrip;
    }
  },

  tripState(state) {
    if (state.trip) {
      return state.trip.state;
    }
  },

  tripTaxiId(state) {
    if (state.trip) {
      return state.trip.taxiId;
    }
  },

  tripTaxiName(state) {
    if (state.trip) {
      return state.trip.taxiName;
    }
  },

  tripPrice(state) {
    if (state.trip) {
      return state.trip.price;
    }
  },

  tripDriverName(state) {
    if (state.trip) {
      return state.trip.driverName;
    }
  },

  tripDriverPhone(state) {
    if (state.trip) {
      return state.trip.driverPhone;
    }
  },

  tripPortalCoords(state) {
    if (state.trip) {
      return state.trip.service ? state.trip.service?.streetFromDisplay?.portal?.coords : null;
    }
  },

  isTripFinished(state) {
    if (state.trip) {
      return state.trip.state === 7;
    }
  },

  tripTrack(state) {
    if (state.trip) {
      return state.trip.track ? state.trip.track : null;
    }
  },

  tripTrackFree(state) {
    const trips = [];

    if (state.trip && state.trip.track) {
      // We should use the last bt state on the points where bt has no value
      // assuming the value has not been changed.
      let lastBtState = null;
      const freePoints = state.trip.track
        .map((p, i) => {
          const state = p.btState || lastBtState;
          const _lastState = lastBtState;
          lastBtState = state;
          if (state === 3 || _lastState === 3) {
            return i;
          }
        })
        .filter((a) => a);

      let trip = 0;
      trips[trip] = [];
      freePoints.forEach((trackIndex, freePointsIndex) => {
        if (trackIndex > freePoints[freePointsIndex - 1] + 2) {
          trips[++trip] = [];
        }
        trips[trip].push(state.trip.track[trackIndex]);
      });
    }

    return trips;
  },

  tripTrackBusy(state) {
    if (state.trip && state.trip.track) {
      // We should use the last bt state on the points where bt has no value
      // assuming the value has not been changed.
      let lastBtState = null;
      const trackBusyPoints = state.trip.track
        .map((p, i) => {
          const state = p.btState || lastBtState;
          lastBtState = state;
          if (state === 4) {
            return i;
          }
        })
        .filter((a) => a);

      // This is a hacky way of avoid the path splitting on the map representation
      // Consists in add the next point in the path if this track has more points
      // after end the busy track.
      if (trackBusyPoints[trackBusyPoints.length - 1] < state.trip.track?.length - 1) {
        trackBusyPoints.push(trackBusyPoints[trackBusyPoints.length - 1] + 1);
      }

      return trackBusyPoints.map((i) => state.trip.track && state.trip.track[i]);
    }
  },

  tripTrackPickedUpClient(state) {
    if (state.trip && state.trip.track) {
      const position = state.trip.track?.find((point) => point.pickedUpClient);
      return position ? position : null;
    }
  },

  tripTrackStartPosition(state) {
    if (state.trip && state.trip.track) {
      return state.trip.track ? state.trip.track[0] : [];
    }
  },

  tripTrackLastPosition(state) {
    if (state.trip && state.trip.track) {
      return state.trip.track[state.trip.track?.length - 1];
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
